export enum FrequencyPlanChannelType {
  Multi = 'multi',
  Std = 'std',
  Fsk = 'fsk',
}
